export default {
    firstToCreate: 'Hãy là người đầu tiên tạo chủ đề trong diễn đàn này',
    firstToPostInCategory: 'Hãy là người đầu tiên đăng bài trong danh mục này',
    firstToRespondToTopic: 'Hãy là người đầu tiên trả lời chủ đề này!',
    createNewThread: 'Tạo chủ đề mới',
    thread: 'chủ đề',
    viewThread: 'Xem chủ đề',
    replies: 'Phản hồi',
    noReplies: 'Không có phản hồi',
    reply: 'trả lời',
    _reply: 'Trả lời',
    ReplyTo: 'Trả lời',
    replyToThisQuestion: 'Trả lời câu hỏi này',
    onceRepliedModeratorMayRespond: 'Sau khi bạn trả lời, người điều hành diễn đàn có thể phản hồi lại',
    onceRepliedCanViewResponses: 'Sau khi bạn trả lời, bạn có thể xem phản hồi của những người tham gia khác',
    loadingResponses: 'Đang tải phản hồi',
    hideXReplies: 'Ẩn {count} phản hồi',
    showXReplies: 'Hiển thị {count} phản hồi',
    hideMostRecentReplies: 'Ẩn phản hồi gần đây nhất',
    showMostRecentReplies: 'Hiển thị phản hồi gần đây nhất',
    post: 'Đăng bài',
    message: 'Tin nhắn',
    typeMessage: 'Nhập tin nhắn',
    addPost: 'Thêm bài đăng',
    addMessage: 'Thêm tin nhắn',
    editPost: 'Chỉnh sửa bài đăng',
    editPostWithMedia: 'Chỉnh sửa bài đăng có phương tiện',
    createPostWithMedia: 'Tạo bài đăng có phương tiện',
    deleteMessage: 'Xóa tin nhắn',
    deleteMessageConfirm: 'Bạn có chắc chắn muốn xóa tin nhắn này không',
    pinPost: 'Ghim bài đăng',
    media: 'Phương tiện',
    uploadMedia: 'Tải lên phương tiện',
    categories: 'danh mục',
    goBack: 'Quay lại',
    goBackPrevious: 'Quay lại trang trước',
    goBackToCategory: 'Quay lại danh mục {name}',
    loadingLatestThreads: 'Đang tải các chủ đề mới nhất',
    loadingDiscussionForum: 'Đang tải diễn đàn thảo luận',
    dontShowAgainForTask: `Không hiển thị lại cho nhiệm vụ này`,
    title: 'Tiêu đề',
    beTheFirst: 'Hãy là người đầu tiên trả lời chủ đề này'
};
